import React from 'react';
import { motion } from 'framer-motion';
import { User, Users, ArrowRight, Baby } from 'lucide-react';
export function ServicesSection() {
  const services = [{
    title: 'Terapia para Adultos',
    subtitle: 'Individual',
    description: 'Un espacio personal para trabajar en tu bienestar emocional. Te acompaño en el manejo de estrés, ansiedad, depresión, autoestima, cambios de vida, duelo y relaciones.',
    icon: User
  }, {
    title: 'Terapia Infantil',
    subtitle: 'Para niños',
    description: 'Acompañamiento terapéutico para niños con dificultades emocionales, conductuales o de adaptación. Trabajo con técnicas apropiadas para su edad en un ambiente seguro.',
    icon: Baby
  }, {
    title: 'Crianza Respetuosa',
    subtitle: 'Para padres y cuidadores',
    description: 'Orientación práctica para criar con empatía: establecer límites saludables, mejorar la comunicación familiar y fortalecer la regulación emocional en el hogar.',
    icon: Users
  }];
  return <section id="services" className="py-24 bg-gray-50" data-id="element-205">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-206">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-207">
          <h2 className="font-serif text-3xl sm:text-4xl font-bold text-gray-900 mb-4" data-id="element-208">
            Servicios
          </h2>
          <p className="text-lg text-gray-600" data-id="element-209">
            Acompañamiento profesional adaptado a tus necesidades y etapa de
            vida.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-210">
          {services.map((service, index) => {
          const Icon = service.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-white rounded-2xl p-8 shadow-sm border border-gray-200 hover:shadow-md transition-shadow" data-id="element-211">
                <div className="w-12 h-12 bg-teal-50 rounded-full flex items-center justify-center mb-6" data-id="element-212">
                  <Icon className="w-6 h-6 text-teal-700" data-id="element-213" />
                </div>

                <h3 className="font-serif text-xl font-bold text-gray-900 mb-2" data-id="element-214">
                  {service.title}
                </h3>
                <p className="text-sm font-bold text-teal-700 uppercase tracking-wide mb-4" data-id="element-215">
                  {service.subtitle}
                </p>
                <p className="text-gray-600 leading-relaxed mb-8 min-h-[80px]" data-id="element-216">
                  {service.description}
                </p>

                <a href="#contact" className="inline-flex items-center text-teal-700 font-medium hover:text-teal-800 transition-colors" data-id="element-217">
                  Más información
                  <ArrowRight className="w-4 h-4 ml-2" data-id="element-218" />
                </a>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}